const en ={
    navbar : {
        home : "Home",
        aboutMe : "About Me",
        education : "Education",
        employment : "Employment History",
        achievements : "Achievements",
        research    : "Research",
        projects : "Projects",
        collab : "Collab",
    },
    home : {
        desc : "Hey guys, welcome to my homepage. My name is Eduardo Iglesius. This site is one of my personal projects, used as a digital portfolio similar to LinkedIn. Here, I'll be sharing my achievements and various projects that  I made alone or with my friends. I hope you find it interesting. For contact information and more, please scroll down. Enjoy your visit!",
        news : {
            hackathon : "Received Excelence Award from Hackathon Track Job",
            masterHandai : "Started master degree in Osaka University",
            graduateHandai : " Graduated from Osaka University (Bachelor Degree)",
            mextMaster : "Received MEXT Scholarship for master",
            cChannel : "Started working as Web Developer in C-Channel Japan",
            helloSensei : "Started working as Indonesian teacher in Hello Sensei",
            wasabi : "Started working as translator in Mori Kosan",
            headInternal : "Became Head of Internal in PPI-ON",
            memberInternal : "Became member of Internal in PPI-ON",
            bachelorHandai : "Started bachelor degree in Osaka University",
            jlc : "Started japanese school in Japanese Language Center for International Students",
            mextBachelor : "Received MEXT Scholarship for bachelor",
            advancedRobotics : "Accepted for publication in Advanced Robotics",
            robomech : "Presented at ROBOMECH 2025 in Yamagata",
            moneyForward : "Started internship at MoneyForward",
        },
    },
    aboutMe : {
        aboutMe : "About Me",
        name : "Name",
        age : "Age",
        nationality : "Nationality",
        occupation : "Occupation",
        hobby : "Hobby",
        language : "Language",
        interest : "Interest",
        indonesia : "Indonesia",
        masterStudent : "Master Student"
    },
    education : {
        education : "Education",
        westKalimantan : "West Kalimantan",
        westJawa : "West Jawa",
        indonesia : "Indonesia",
        elementary_title : "Immanuel Elementary School",
        junior_title : "Immanuel Junior High School",
        senior_title : "Immanuel Senior High School",
        itb_title : "Bandung Institute of Technology",
        handai_title : "Osaka University",
        jlc_title : "Japanese Language Center for International Students",
        elementary : "Elementary School",
        junior : "Junior High School",
        senior : "Senior High School",
        itb_desc : "Undergraduate. Spent only a few months in this university before finally got a scholarship to Japan.",
        osaka : "Osaka",
        tokyo : "Tokyo",
        japan : "Japan",
        jlc : "Japanese Language School. Japanese preparatory school before attending university in Japan.",
        handai_under : "Undergraduate",
        handai_master : "master",
    },
    employment : {
        employment : "Employment",
        wasabi_title : "Indonesian-English-Japanese Translator",
        wasabi_loc : "Mori Kosan Co,. Ltd. Osaka, Japan",
        wasabi_desc : "Translating article, news, SNS caption between Indonesian, English, and Japanese language only for the short term because of the tight university schedule.",
        hello_title : "Indonesian Teacher",
        hello_loc : "Hello Sensei, Japan",
        hello_desc : "Teaching Japanese students from various range of ages in Indonesian language.",
        web_title : "Software Engineer Intern",
        web_loc : "C-channel. Tokyo, Japan",
        web_desc : "Developing a page by designing the page using react and typescript and managing the database by using MongoDB and MySQL.",
        teamlab_title : "Front End Developer",
        teamlab_loc : "TeamLab. Tokyo, Japan",
        teamlab_desc : "Designing the page using React and Next.js. Creating local navigation for the page that follows the page when it is scrolled, and adding function to filter data shown on the page",
        amazon_title : "Software Development Engineer Intern",
        amazon_loc : "Amazon. Tokyo, Japan",
        amazon_desc : "Getting the chance to learn how to use Amazon AWS services to create another service, while also gaining a deeper understanding of the leadership principles at Amazon.",
        mf_title : "Software Engineer Intern",
        mf_loc : "Money Forward, Inc. Tokyo, Japan",
        mf_desc : "Developing Front End, Back End, making unit test, integration test and E2E test."
    },
    month : {
        present : "Present",
        january : "January",
        february : "February",
        march : "March",
        april : "April",
        may : "May",
        june : "June",
        july : "July",
        august : "August",
        september : "September",
        october : "October",
        november : "November",
        december : "December",
    },
    achievements : {
        achievements : "Achievements",
        key : {
            name : "Name",
            year : "Year",
            desc : "Desc",
        },
        hackathon_desc : "An award issued by Track Job, given to the outstanding team for the overall idea, implementation, and presentation that were conducted within 2 weeks.",
        gakubusho_desc : "An award issued by Osaka University, given to one outstanding student from the course who is currently enrolled in Osaka University",
        mextMaster_desc : "A scholarship funded by the Japanese Ministry of Education, Culture, Sports, Science and Technology (MEXT), supports foreign students studying in Japan. It covers tuition, provides a monthly stipend, and include travel expenses to and from Japan.",
        tpbsho_desc : "An award issued by Osaka univeristy, Honored to students who excel in liberal arts education, focusing on one of the university's educational goals. It evaluates overall achievements including credits earned and academic performance. Annually, around 50 students out of 3000s students from across all faculties are selected, based on their accomplishments by the end of their second year, including those in the International College's English courses by their third year.",
        mextBach_desc : "A scholarship funded by the Japanese Ministry of Education, Culture, Sports, Science and Technology (MEXT), supports foreign students studying in Japan. It covers tuition, provides a monthly stipend, and include travel expenses to and from Japan.",
        other_desc : "Any other awards that I received during my elementary high school to senior high school. All will be shown in the picture."
    },
    research : {
        research : "Research",
        detail : "For More Details"
    },
    project : {
        title : "My Little Projects",
        key : {
            name : "Name",
            year : "Year",
            desc : "Desc",
        },
        bi_name : "Bad Interface",
        bi_desc : "Bad interface idea for a login page, name can be set by using scroll bar and the PIN can be set by using russian roullete.",
        hp_name : "Homepage",
        hp_desc : "My own homepage, used as digital portofolio similar to LinkedIn. In this web, I will be sharing my achievements and various projects that I made with my own style.",
        todo_name : "To-Do-List Android App",
        todo_desc : "An android app to insert your to-do-list. Users can choose their own date and activity and it will appear on the app. User can also delete the activity once it is over. This project was made as my first step towards app development",
        calculator_name : "Calculator Web Service",
        calculator_desc : "A simple calculator web service where user can do simple calculation. This project was made as my first step towards web development.",
    },
    collab : {
        title : "Collaboration",
        key : {
            name : "Name",
            year : "Year",
            desc : "Desc",
        },
        image_name : "Automatic Image Cropper",
        image_desc : "A computer vision with 1 image input and then the program will immediately crop the main quadilateral object in the image and print it as a new image. Credit to 西田 直生, 忠谷 晃佑、北村 祐稀.",
        vr_name : "脱出迷路",
        vr_desc : "A 1v1 VR game between two players. One player plays the role of the Game Master, controlling the maze and its dynamics through a computer interface. The opposing player, immersed in a virtual reality environment, takes on the role of a player. The objective of the player is to escape the labyrinth by collecting keys and various items within the time limit, all while avoiding the traps set by the Game Master and evading monsters that lurk within. Credit to 西 滉平, 年藤 悠歩, 佐⼭ 幸翼, 玉置 文人.",
        hackathon : "A mobile app where user can use their phone cameras to scan the bill when they go to a trip and split it among the others. Credit to : 西 滉平, 吉崎 響, 和坂 優佑, 丸山 結, Buamanee Thanpimon.",
        ivrc : "A VR project where users can enter a painting and paint within the world of the painting using provided objects. Credit to : Junshu An, Buamanee Thanpimon, Toma Oya, Lee Gayeon, Chou",
        uroom : "Room reservation web system. This web system implements frontend, backend, and database for scalable development in the future. Credit to Junshu An."
    },
    footer : {
        contact : "Contact",
        professional : "Professional Platform",
        personal : "Personal Platform",
        credits : "Credits"
    }
}

export default en;